import React from "react";

import {
  AccordionSummary,
  AccordionDetails,
  AccordionProps as MuiAccordionProps,
} from "@mui/material";
import {
  AccordionCollapsedIcon,
  AccordionExpandedIcon,
  StyledAccordion,
} from "./Accordion.styles";
import { Typography } from "../Typography/Typography";

export const LINE_BREAK = <br />;

export interface AccordionProps extends Omit<
  MuiAccordionProps,
  "children" | "title" | "content"
> {
  title: React.ReactNode;
  titleAccessory?: React.ReactNode;
  content: React.ReactNode;
  key: string;
  padding?: string;
}

export const Accordions: React.FC<{
  data: AccordionProps[];
}> = ({ data }) => {
  const [expanded, setExpanded] = React.useState<string | false>("");

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  const getTypographySections = (
    content: React.ReactNode,
    isTitle: boolean,
    padding?: string,
  ): React.ReactElement => (
    <Typography
      key={content as string}
      size={isTitle ? "large" : "medium"}
      isBold={isTitle}
      isCaps={false}
      isItalic={false}
      padding={padding}
      content={content}
    />
  );
  const accordions = data.map((accordionSections) => (
    <StyledAccordion
      expanded={expanded === accordionSections.key}
      onChange={handleChange(accordionSections.key)}
      key={accordionSections.key}
    >
      <AccordionSummary
        expandIcon={
          expanded === accordionSections.key ? (
            <AccordionExpandedIcon className="accordion-arrow-icon" />
          ) : (
            <AccordionCollapsedIcon className="accordion-arrow-icon" />
          )
        }
        aria-controls={`${accordionSections.key}-panel-content`}
        id={`${accordionSections.key}-help`}
      >
        {getTypographySections(accordionSections.title, true)}
        {accordionSections.titleAccessory}
      </AccordionSummary>
      <AccordionDetails>
        {typeof accordionSections.content === "string"
          ? getTypographySections(
              accordionSections.content,
              false,
              accordionSections.padding,
            )
          : accordionSections.content}
      </AccordionDetails>
    </StyledAccordion>
  ));

  return <>{accordions}</>;
};
